import Image from "./Image";

export default function TestimonialSection({
  body,
  bodyEmphasis,
  author,
  organization,
  logo,
}) {
  return (
    <section className="mt-12 lg:mt-24">
      <div className="relative max-w-screen-xl mx-auto px-8 sm:px-6 lg:px-8">
        <div className="relative">
          {logo && (
            <Image src={`/images/logos/${logo}.png`} className="mx-auto h-10" />
          )}
          <blockquote className="mt-8">
            <div className="max-w-3xl mx-auto text-left text-xl leading-7 sm:text-2xl sm:leading-9 font-medium text-gray-900">
              <p>
                &ldquo;{body}
                {bodyEmphasis ? (
                  <span className="block mt-3">
                    <span className="font-bold">bodyEmphasis</span>
                    &rdquo;
                  </span>
                ) : (
                  <>&rdquo;</>
                )}
              </p>
            </div>
            <footer className="mt-8">
              <div className="md:flex md:items-center md:justify-center">
                <div className="mt-3 text-center md:mt-0 md:ml-4 md:flex md:items-center">
                  <div className="text-base leading-6 font-medium text-gray-900">
                    {author}
                  </div>

                  <svg
                    className="hidden md:block mx-1 h-5 w-5 text-red-600"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path d="M11 0h3L9 20H6l5-20z" />
                  </svg>

                  <div className="text-base leading-6 font-medium text-gray-500">
                    {organization}
                  </div>
                </div>
              </div>
            </footer>
          </blockquote>
        </div>
      </div>
    </section>
  );
}
